module.exports = __webpack_public_path__ + "img/Apoptosis-OSCC_GSE208253.8c643913.png";